var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseDrawer',{ref:"baseDrawer",attrs:{"title":"Add/Hide Columns","subtitle":"Select or re-arrange columns to display"}},[_c('DragAndDropEditColumnsList',{attrs:{"get-columns":_vm.getColumns,"module":"comparison"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }